<template>
    <div class="printing">
        <div class="printing_title">图文快印</div>
        <div class="printing_center" v-if="dataList.length">
            <div class="row">
                <div class="col-md-3 center_left">
                    <img src="../../assets/printing/img9.png" alt="/">
                    <div>
                        <p>操作指引</p>
                        <div></div>
                    </div>
                </div>
                <div class="col-md-9 center_right1">
                    <div v-for="(item,index) of dataList[0].data" :key='index' @click="jumpFun(item.url)">
                        <p>{{item.name}}</p>
                        <p>{{item.ps}}</p>
                        <img  src="../../assets/printing/img6.png" alt="/">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 center_left">
                    <img src="../../assets/printing/img7.png" alt="/">
                    <div>
                        <p>软件下载</p>
                        <div></div>
                    </div>
                </div>
                <div class="col-md-9 center_right2">
                    <div v-for="(item,index) of dataList[1].data" :key="index">
                        <img v-if="index==0" src="../../assets/printing/img4.png" alt="/">
                        <img v-else src="../../assets/printing/img3.png" alt="/">
                        <div class="center_right2_tit">
                            <p>{{item.name}}<span>{{item.time|timeFun}}</span></p>
                            <p v-if="index==0">从此收钱更轻松。</p>
                            <p v-else>打印什么的，都交给我吧。</p>
                        </div>
                        <div class="center_right2_dow">
                            <button class="btn btn-primary" @click="jumpFun(item.url,true)">下载</button>
                            <p>（ {{item.version}} ）</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 center_left">
                    <img src="../../assets/printing/img8.png" alt="/">
                    <div>
                        <p>常见问题</p>
                        <div></div>
                    </div>
                </div>
                <div class="col-md-9 center_right3">
                    <div v-for="(item,index) of dataList[2].data" :key="index">
                        <div>
                            <img v-if="index==0" src="../../assets/printing/img1.png" alt="/">
                            <img v-else src="../../assets/printing/img2.png" alt="/">
                            <span>{{item.name}}</span>
                        </div>
                        <p v-for="(item2,index2) of item.data" :key="index2"><span @click="switchFun('issueSolving',item,index2)">{{item2.name}}</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "./mixin"
export default {
    mixins:[mixin],
    data(){
        return{
            dataList:[]
        }
    },
    methods:{
        getDataListFun(){//获取数据
            axios
            .get(`/ProductSystem/Issue/TreeList?id=4`)
            .then(res=>{
                if (res.isSuccess) {
                        this.dataList=JSON.parse(res.data)
                        console.log(this.dataList)
                } else {
                    this.dataList=[]
                    this.$layer.alert("获取数据异常!");
                }
            })
        },
        jumpFun(url,boo){
            if(url){
                if(boo){
                    window.location.href=url//下载
                }else{
                    window.open(url);//预览
                }
            }
        },
    },
    created(){
        window.scrollTo(0, 0);
        this.getDataListFun()
    },
    filters:{
        timeFun(val){
            var time = new Date(val);
            var y = time.getFullYear();
            var m = time.getMonth()+1;
            var d = time.getDate();
            return y+"-"+m+"-"+d
        }
    }
}
</script>

<style  scoped>
.printing{
    padding: 90px 0 0;
    color: #18182A;
    font-size: 22px;
}
.printing_title{
    font-size: 40px;
    text-align: center;
    line-height: 37px;
}
.printing_center{
    border-top: 1px solid #D3DCF5;
    max-width: 1200px;
    margin: 60px auto 0;
}
.row{
    width: 100%;
    margin: 0;
}
.center_left{
    display: flex;
    height: 246px;
}
.center_left img{
    margin: 78px 24px 0 0;
    width: 91px;
    height: 91px;
}
.center_left>div{
    margin-top: 98px;
}
.center_left>div>p{
    line-height: 22px;
    font-weight: 800;
}
.center_left>div>div{
    width: 31px;
    border-top: 2px solid #1B8AF9;
}
.center_right1{
    padding: 44px 0 24px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D3DCF5;
    flex-wrap: wrap;
}
.center_right1>div{
    width: 375px;
    height: 158px;
    box-shadow:0px 0px 21px 0px rgba(51,120,210,0.1);
    position: relative;
    padding: 41px 0 55px 43px;
    margin-bottom: 20px;
    overflow: hidden;
}
.center_right1>div:hover{
    cursor: pointer;
}
.center_right1>div>p:nth-of-type(1){
    font-size: 22px;
    line-height: 22px;
    margin-bottom: 23px;
}
.center_right1>div>p:nth-of-type(2){
    font-size: 18px;
    line-height: 18px;
    opacity: 0.6;
}
.center_right1>div>img{
    position: absolute;
    right: -21px;
    bottom: -18px;
    width: 120px;
    height: 120px;
}
.center_right2{
    padding: 44px 0;
    border-bottom: 1px solid #D3DCF5;
}
.center_right2>div{
    width: 100%;
    box-shadow:0px 0px 21px 0px rgba(51,120,210,0.1);
    padding: 43px 46px 18px;
    display: flex;
}
.center_right2>div:nth-of-type(1){
    margin-bottom: 24px;
}
.center_right2>div>img{
    width: 65px;
    height: 68px;
    margin-right: 47px;
}
.center_right2_tit{
    flex: 1;
}
.center_right2_tit P:nth-of-type(1){
    font-size: 20px;
    font-weight: 700;
}
.center_right2_tit P:nth-of-type(1) span{
    opacity:0.6;
    font-size: 16px;
    font-weight: 400;
    margin-left: 17px;
}
.center_right2_tit P:nth-of-type(2){
    font-size: 16px;
    opacity:0.6;
}
.center_right2_dow button{
    width:140px;
    height:44px;
    background:rgba(27,138,249,1);
    border-radius:22px;
    margin-bottom: 13px;
}
.center_right2_dow p{
    font-size:16px;
    color:rgba(24,24,42,1);
    opacity:0.3;
    width:140px;
    text-align: center;
}

.center_right3{
    padding: 44px 0;
    display: flex;
    margin-bottom: 100px;
}
.center_right3>div{
    flex: 1;
}
.center_right3>div>div{
    margin-bottom: 7px;
}
.center_right3>div>div img{
    width: 32px;
    height: 28px;
    margin-right: 15px;
}
.center_right3>div>div span{
    font-weight: 800;
    line-height: 28px;
}
.center_right3>div>p{
    line-height: 50px;
    width: 225px;
    border-bottom: 1px solid #EBEEF5;
    font-size: 18px;
    color: #555555;
}
.center_right3>div>p>span:hover{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comm/printing.vue